import { ButtonGroup, ButtonGroupProps } from "@chakra-ui/react";
import React from "react";

const inactiveStyles = {
  bg: "transparent",
  borderColor: "cherryBorder.200",
  borderWidth: "1px",
  _hover: { bg: "gray.50" },
  _active: { bg: "gray.100" },
};

const activeStyles = {
  bg: "cherryPink.100",
  borderColor: "cherryRed.100",
  borderWidth: "1px",
  _hover: { bg: "cherryPink.100" },
  _active: { bg: "cherryPink.100" },
};

export interface ToggleButtonGroupProps {
  onChange: (value: string) => void;
  value: string;
  children: React.ReactNode;
  buttonGroupProps?: ButtonGroupProps;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  onChange,
  value,
  children,
  buttonGroupProps,
}) => {
  if (!children) {
    throw new Error("ToggleButtonGroup requires children");
  }

  return (
    <ButtonGroup {...buttonGroupProps}>
      {React.Children.map(children as React.ReactElement[], (child) => {
        const isActive = value === child?.props?.value;
        return React.cloneElement(child, {
          onClick: () => {
            if (isActive) return;
            onChange(child?.props?.value);
          },
          sx: isActive ? activeStyles : inactiveStyles,
        });
      })}
    </ButtonGroup>
  );
};
